import React, { useState } from "react";
import "./SelectInputPercentage.css";
import Select from "react-select";
import CustomError from "../Errors/CustomError";
import Asterisks from "../Asterisks/Asterisks";

const SelectInputPercentage = ({
  label,
  options,
  value,
  onSelect,
  noDataMessage = "no data..",
  maxMenuHeight = 200,
  isClearable = false,
  placeholder = "Select",
  parentClassName = "",
  selectClassName = "",
  labelClassName = "",
  parentStyle = {},
  selectStyle = {},
  labelStyle = {},
  customError,
  asterisk,
  disabled=false,
}) => {
  const [inputValue, setInputValue] = useState("");

  const customFilterOption = (option, input) => {
    if (!input.includes("%")) {
      return false;
    }

    const regex = new RegExp(input.replace("%", "").trim(), "i");
    return regex.test(option.label);
  };

  const handleInputChange = (newInputValue) => {
    setInputValue(newInputValue);
  };

  return (
    <div
      className={
        parentClassName && parentClassName.trim() !== ""
          ? parentClassName
          : "default-single-select-parent-class"
      }
      style={parentStyle}>
      <label
        className={
          labelClassName && labelClassName.trim() !== ""
            ? labelClassName
            : "default-single-select-label-class"
        }
        style={labelStyle}>
        {label} <Asterisks asterisk={asterisk} />
      </label>
      <div className="input-wrapper">
        <Select
          value={value}
          onChange={onSelect}
          options={options}
          classNamePrefix="select2-selection"
          placeholder={placeholder}
          className={`${selectClassName} ${customError ? "input-error" : ""}`}
          styles={{
            ...selectStyle,
            control: (provided, state) => ({
              ...provided,
              borderColor: customError
                ? "#d15757"
                : state.isFocused
                ? "blue"
                : "#ccc",
              boxShadow: customError
                ? "0 0 3px rgba(255, 0, 0, 0.5) "
                : state.isFocused
                ? "0 0 0 1px blue"
                : "none",
              "&:hover": {
                borderColor: customError
                  ? "#d15757"
                  : state.isFocused
                  ? "blue"
                  : "#ccc",
              },
            }),
            menu: (provided) => ({
              ...provided,
              borderColor: "#ccc",
              zIndex: 30000,
            }),
            option: (provided, state) => ({
              ...provided,

              padding: "10px",
              margin: "2px 8px",
              width: "calc(100% - 16px)",
              boxSizing: "border-box",
            }),
             placeholder: (provided) => ({
              ...provided,
              textTransform: "capitalize", 
            }),
          }}
          menuPortalTarget={document.body}
          noOptionsMessage={() => noDataMessage}
          maxMenuHeight={maxMenuHeight}
          isClearable={isClearable}
          filterOption={customFilterOption}
          onInputChange={handleInputChange}
          inputValue={inputValue}
          isDisabled={disabled}
        />
        {customError && (
          <i className="fas fa-exclamation-circle error-icon"></i>
        )}
      </div>
      {customError && <CustomError error={customError} />}
    </div>
  );
};

export default SelectInputPercentage;
